export default __webpack_public_path__ + "static/media/backgroundImage.9a17f9f2.jpg";